import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/storage';
import moment from 'moment';
import Compressor from 'compressorjs'; // for compressing image size before upload

const uploadPostImage = async (imageFile: any, postTitle: string) => {
  // compress the image
  imageFile = await new Promise((resolve, reject) => {
    new Compressor(imageFile, {
      maxWidth: 1500,
      quality: 0.6,
      success: resolve,
      error: reject,
    });
  });
  // upload the post image file to Firebase Storage
  const extension = imageFile.name.split('.').pop();
  const fileName = `${moment().format('YYYYMMDDHHmmss')}-${postTitle.substring(0, 10)}.${extension}`;
  const snapshot = await firebase.storage().ref(`posts-${fileName}`).put(imageFile);
  return await snapshot.ref.getDownloadURL();
}

export default {
  async banUser(bannedUserId: any, postId: any = "") {
    return (await firebase.app().functions('asia-east2').httpsCallable('post-banUser')({ bannedUserId, postId })).data;
  },
  async unbanUser(targetUserId: any) {
    return (await firebase.app().functions('asia-east2').httpsCallable('post-unbanUser')({ targetUserId })).data;
  },
  async reportPost(postId: any, description: any, isPostComment: any) {
    return (await firebase.app().functions('asia-east2').httpsCallable('post-reportPost')({ postId, description, isPostComment })).data;
  },

  // READ
  async getAllPosts() {
    return (await firebase.app().functions('asia-east2').httpsCallable('post-getAllPosts')()).data;
  },
  async getPostById(id: any) {
    const res = await firebase.app().functions('asia-east2').httpsCallable('post-getPostById')({ id });
    return res.data[0];
  },
  async getPostComments(postId: any) {
    return (await firebase.app().functions('asia-east2').httpsCallable('post-getPostComments')({ postId })).data;
  },

  // UPDATE
  async updatePost(postId: any, postTitle: string, postContent: string, postImageLink: any, imageFile: any = null, originalImageLink: any = null) {
    if (imageFile) {
      if (originalImageLink) firebase.storage().refFromURL(originalImageLink).delete(); // delete the old image from Firebase Storage
      postImageLink = await uploadPostImage(imageFile, postTitle);
    }
    return await firebase.app().functions('asia-east2').httpsCallable('post-updatePost')({ postId, postTitle, postContent, postImageLink });
  },
  async updatePostReaction(postId: any, reaction = "like") {
    return await firebase.app().functions('asia-east2').httpsCallable('post-updatePostReaction')({ postId, reaction });
  },
  async updatePostCommentReaction(commentId: any, reaction = "like") {
    return await firebase.app().functions('asia-east2').httpsCallable('post-updatePostCommentReaction')({ commentId, reaction });
  },

  // CREATE
  async addNewPost(postTitle: any, postContent: any, imageFile: any = null) {
    let postImageLink = ""; // post image URL
    if (imageFile) {
      postImageLink = await uploadPostImage(imageFile, postTitle);
    }
    return await firebase.app().functions('asia-east2').httpsCallable('post-addNewPost')({ postTitle, postContent, postImageLink });
  },
  async addNewPostComment(postId: any, content: any) {
    return await firebase.app().functions('asia-east2').httpsCallable('post-addNewPostComment')({ postId, content });
  },

  // DELETE
  async deletePost(postId: any, postImageLink: any) {
    if (postImageLink) firebase.storage().refFromURL(postImageLink).delete(); // delete the post image from Firebase Storage
    return await firebase.app().functions('asia-east2').httpsCallable('post-deletePost')({ postId });
  }
}